import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import toast from "./reducers/toast";
import auth from "./reducers/auth";
import filter from "./reducers/filter";
import api from "./reduxQuery/api";
import { rtkQueryErrorLogger } from "./reduxQuery/middleware/errorHandler";
import { crossTabSyncMiddleware } from "./reduxQuery/middleware/crossTabMiddleware";
import { setupCrossTabSync } from "./reduxQuery/crossTabSync";

// Configure persist for filter reducer only
const filterPersistConfig = {
  key: "filter",
  storage,
};

// Create persisted filter reducer
const persistedFilterReducer = persistReducer(filterPersistConfig, filter);

export const store = configureStore({
  reducer: {
    api: api.reducer,
    toast,
    auth,
    filter: persistedFilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(api.middleware, rtkQueryErrorLogger, crossTabSyncMiddleware),
});

// Create persistor
export const persistor = persistStore(store);

// Initialize cross-tab cache sync (broadcasts cache invalidations between tabs)
setupCrossTabSync(store.dispatch);

// Enable refetchOnReconnect behavior (refetchOnFocus is disabled in api.ts)
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
